export default "__VITE_ASSET__GHtFRZck__"